import { Component, OnInit, Input, Self, Optional, ViewChild, Output, EventEmitter, HostBinding } from '@angular/core';
import { NgControl, ControlValueAccessor } from '@angular/forms';
import { Icon } from '@bciti/types';
import * as uuid from 'uuid';

@Component({
    selector: 'app-confirm-form-input',
    templateUrl: './confirm-input.component.html',
    styleUrls: ['./confirm-input.component.scss'],
})
export class ConfirmFormInputComponent implements OnInit, ControlValueAccessor {
    public Icon = Icon;

    public onChange: (x?: any) => void = () => {};

    public onTouched: (x?: any) => void = () => {};

    public id: string;

    public _value: any = '';

    @Input() disabled: boolean;

    @Input() label = '';

    @Input() placeholder: string;

    @Input() popoverTitle: string;

    @Input() popoverBody: string;

    @Input() type: 'text' | 'email' | 'password' | 'phone' | 'number' = 'text';

    @Input() autocomplete = false;

    @Input() validation = true;

    @Output('change') changeOutput = new EventEmitter<any>();

    @Output() blurEvent = new EventEmitter();

    @ViewChild('input', { static: true }) input;

    @Input() appendButtonIcon: string;

    @Output() buttonIconClick = new EventEmitter<any>();

    @Input() disableMessages = false;

    @Input() hint: string;

    @Input() mask = null;

    @Input() maxLength = 99999999;

    @Input() pattern: RegExp;

    @Input() inputmode: string;

    @Input() changeInput = false;

    @Input() previousInput: string;

    constructor(@Self() @Optional() private ngControl: NgControl) {
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    get invalid(): boolean {
        if (this.ngControl) {
            return this.ngControl.invalid;
        }
        return false;
    }

    get valid(): boolean {
        if (this.ngControl) {
            return this.ngControl.valid;
        }
        return false;
    }

    get pristine(): boolean {
        if (this.ngControl) {
            return this.ngControl.pristine;
        }
        return false;
    }

    get dirty(): boolean {
        if (this.ngControl) {
            return this.ngControl.dirty;
        }
        return false;
    }

    get touched(): boolean {
        if (this.ngControl) {
            return this.ngControl.touched;
        }
        return false;
    }

    ngOnInit(): void {
        this.id = uuid.v4();
    }

    get value(): any {
        return this._value;
    }

    set value(v) {
        this._value = v;
        if (this.onChange) {
            this.changeOutput.emit(v);
            this.onChange(v);
            // Workaround. Validations were being called despite field/form being initalized to updateOn: 'blur'
            // this.onTouched();
        }
    }

    valueChange(v): void {
        this.value = v;
    }

    writeValue(value: any): void {
        this._value = value;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    registerOnChange(fn: any): void {
        // Store the provided function as an internal method.
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        // Store the provided function as an internal method.
        this.onTouched = fn;
    }

    buttonIconClicked(event): void {
        this.buttonIconClick.emit(event);
    }

    onBlurEvent(event): void {
        this.onTouched();
        this.blurEvent.emit(event);
    }
    clearInput(): void {
        this.value = this.previousInput;
    }
}
